const VEHICLE_FORM_KEY = "vendor_add_vehicle_form_draft";
const VEHICLE_FRESH_FLAG_KEY = "vendor_add_vehicle_fresh_flag";

export interface VehicleFormDraft {
  vehicleNumber: string;
  vehicleType: string;
  vehicleInsurance: string;
  vehicleInsuranceNumber: string;
  vehicleInsuranceExpiry: string;
  vehiclePermitNumber: string;
  vehiclePermitExpiry: string;
  vehiclePollutionNumber: string;
  vehiclePollutionExpiry: string;
  vehicleRCNumber: string;
  vehicleRcExpiry: string;
  capacity: string;
  contractedHours: string;
  contractedKms: string;
  // Note: Files cannot be persisted, so we exclude them
}

export const saveVehicleDraft = (data: Partial<VehicleFormDraft>): void => {
  try {
    // Exclude file fields as they cannot be serialized
    const {
      vehicleImage,
      vehicleInsuranceImage,
      vehiclePermitImage,
      vehiclePollutionImage,
      vehicleRcImage,
      ...serializableData
    } = data as any;
    localStorage.setItem(VEHICLE_FORM_KEY, JSON.stringify(serializableData));
  } catch (error) {
    console.error("Failed to save vehicle form draft:", error);
  }
};

export const loadVehicleDraft = (): VehicleFormDraft | null => {
  try {
    const raw = localStorage.getItem(VEHICLE_FORM_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error("Failed to load vehicle form draft:", error);
    return null;
  }
};

export const clearVehicleDraft = (): void => {
  localStorage.removeItem(VEHICLE_FORM_KEY);
};

export const markVehicleFreshStart = (): void => {
  localStorage.setItem(VEHICLE_FRESH_FLAG_KEY, "true");
};

export const clearVehicleFreshFlag = (): void => {
  localStorage.removeItem(VEHICLE_FRESH_FLAG_KEY);
};

export const isVehicleFreshStart = (): boolean => {
  return localStorage.getItem(VEHICLE_FRESH_FLAG_KEY) === "true";
};

